<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-row>
      <b-col
        v-for="(cards,index) in result"
        :key="index+'fiatCards'"
        class="col-xxl-3 col-sm-12 col-md-6"
      >
        <FiatCard
          :cards="cards"
          :background-img="backgroundImg"
          :background-color="backgroundColor"
          :card-number="cardNumber"
          :deposit-link="'customer-wallets/fiat/deposit/'+cards.currency"
          :widraw-link="'customer-wallets/fiat/withdraw/'+cards.currency"
          :history-link="'customer-wallets/fiat/history/'+cards.currency"
        />
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import FiatCard from '@/modules/crypto/views/theme1/components/wallet/FiatCard.vue'
import fiatIndex from '@/modules/crypto/views/logic/customer-wallets/fiat/index'

export default {
  components: {
    FiatCard,
  },
  mixins: [fiatIndex],
}
</script>
